var RF = function priv($) {

	var publicContent = {};
  publicContent.indicatorLinkingForm = function() {
		var container = jQuery('.indicator-linking-container');
		var updateSelections = function() {
			// Show indicator and subgroup column content based on
			// project/indicator selection
			container.find('.column').not('.projects').each(function() {
				var col = jQuery(this);
				col.find('.no-selection').hide();
				col.find('.filtered-content').each(function() {
					var fc = jQuery(this);
					if (container.find('a.active[data-id="' + fc.attr('data-id') + '"]').length > 0) {
						fc.show();
					} else {
						fc.hide();
					}
				});
				if (col.find('.filtered-content > *:visible').length == 0) {
					col.find('.no-selection').show();
				}
			});
			// Mark project links linked if any of its indicator are selected
			container.find('.column.projects li a').removeClass('linked').each(function() {
				if (container.find('.column.indicators .filtered-content[data-id="' + jQuery(this).attr('data-id') + '"] a.active').length > 0) {
					jQuery(this).addClass('linked');
				}
			});
		};
		container.on('click', '.projects a, .indicators a', function() {
			var a = jQuery(this);
			a.toggleClass('active');

			if (a.is('.indicators a')) {
				a.toggleClass('linked');

				// Enable this indicator (if active).
				a.parent().find('[data-indicator-link]').prop('disabled', !a.is('.active'));
			} else {
				// Remove "active" from other projects
				a.closest("ul").find("a").not(this).removeClass("active");
			}
			updateSelections();
			return false;
		});
		updateSelections();
		container.find('.column.projects a.linked').first().trigger('click');
	}

  return publicContent;
}
window.ResultFramework = RF(jQuery);